module.exports = __webpack_public_path__ + "static/media/overall-risk-popup.6fcc7b0b.png";